import { render, staticRenderFns } from "./ExpertsQuestion.vue?vue&type=template&id=820c4ff4&scoped=true"
import script from "./ExpertsQuestion.vue?vue&type=script&lang=js"
export * from "./ExpertsQuestion.vue?vue&type=script&lang=js"
import style0 from "./ExpertsQuestion.vue?vue&type=style&index=0&id=820c4ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820c4ff4",
  null
  
)

export default component.exports